import React, {PureComponent} from "react"
import styled from "styled-components"
import {InjectedIntl} from "react-intl"
import {Emoji} from "emoji-mart"

import {Body} from "@irati/ui/src/Typography"
import Span from "@irati/ui/src/Link/styled/Span"
import {injectIntl, FormattedMessage} from "@irati/utils/lang"

const TellMeMore = styled.div`
  display: flex;
  margin-bottom: 30px;
`

const MarginLeft = styled.div`
  margin-left: 10px;
`

interface Props extends InjectedIntl {
  emoji: string
  title: string
  onClick: (title: string) => void
}

class TellMeMoreSection extends PureComponent<Props> {
  render() {
    const {emoji, title, onClick, formatMessage} = this.props
    return (
      <TellMeMore>
        <div>
          <Emoji emoji={{id: emoji}} size={14} set="apple" />
        </div>
        <MarginLeft>
          <Body large maxWidth="100%" marginBottom={1}>
            {formatMessage({id: title})}
          </Body>
          <Span bold={false} uppercase={false} inBody onClick={() => onClick(title)}>
            <FormattedMessage id="medical.myMedical.tellMeMore.text" />
          </Span>
        </MarginLeft>
      </TellMeMore>
    )
  }
}

export default injectIntl(TellMeMoreSection)
